export const formatNumber = (value) =>
  new Intl.NumberFormat("id-ID", { minimumFractionDigits: 0 }).format(Math.round(value));

export const camelCase = (str) => {
  const res = str.charAt(0).toUpperCase() + str.slice(1);

  return res;
};

export const formatDate = (timeString, options) => new Intl.DateTimeFormat(
  'id-ID',
  options || {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }
).format(new Date(timeString));

export const formatTime = (timeString, options) => new Intl.DateTimeFormat(
  'id-ID',
  options || {
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  }
).format(new Date(timeString));

export const getTimeZoneName = (timeString) => formatTime(timeString).split(' ')[1];
